import React, { useRef, useState, useEffect } from 'react';

import { PixleeMediaModal } from 'features/pixlee/components';
import { PixleeWidgetItem } from 'features/pixlee/desktop';
import { Carousel } from 'components/Carousel';

import {
	albumDetailsForPDP, modalConfig, slidesToSlide, UGCEventTypes
} from '../constants';
import { PixleeWidget } from '../components';

import './PDPWidget.scss';
import { PixleeOutsideLeftButton, PixleeOutsideRightButton } from 'features/pixlee/desktop/PixleeOutsideButtonGroup';

const PixleeOutsideButtonGroup = ({ setCarouselState, ...rest }) => {

	const { carouselState } = rest;
	useEffect(() => {

		setCarouselState(carouselState);

	}, [ carouselState ]);
	return null;

};

function PDPWidget ({
	productSku, showShopNextPrevButtonToggleOn, gaEvents, onLoadCallback
}) {

	const carouselRef = useRef();
	const [ carouselState, setCarouselState ] = useState();

	return (
		<PixleeWidget
			albumDetails={albumDetailsForPDP}
			productSku={productSku}
			UGCEventTypes={UGCEventTypes.pdp}
			remainingItemsToSlide={12}
			gaEvents={gaEvents}
			onLoadCallback={onLoadCallback}
			activeImageQuerySelector=".PDPWidget .react-multi-carousel-item--active button"
		>
			{(
				updateModalProps,
				inViewRef,
				activeSlideIndex,
				list,
				beforeChange,
				modal,
				show,
				afterChange,
				initialModalSlideIndex
			) => (
				<>
					<div ref={inViewRef}>
						<PixleeOutsideLeftButton
							totalItems={list.data?.length || 0}
							carouselState={carouselState}
							carouselObj={carouselRef.current}
							buttonGroupClassName="pdpWidgetArrows"
							slidesToSlide={slidesToSlide}
						/>
						<Carousel
							renderButtonGroupOutside
							beforeChange={beforeChange}
							afterChange={afterChange}
							arrows={false}
							swipeable={false}
							draggable={false}
							containerClass="PDPWidget"
							ref={carouselRef}
							customButtonGroup={<PixleeOutsideButtonGroup setCarouselState={setCarouselState} />}
						>
							{list.data
								? list.data.map((el, index) => (
									<PixleeWidgetItem
										updateModalProps={updateModalProps}
										key={el.album_photo_id}
										item={el}
										slideIndex={index}
										btnClassName="pdpWidgetArrows"
										isShopNowVisible={false}
										activeSlideIndex={activeSlideIndex}
										carouselObj={carouselRef.current}
										slideToShowCount={6}
									/>
								  ))
								: []}
						</Carousel>
						<PixleeOutsideRightButton
							totalItems={list.data?.length || 0}
							carouselState={carouselState}
							carouselObj={carouselRef.current}
							buttonGroupClassName="pdpWidgetArrows"
							slidesToSlide={slidesToSlide}
						/>
					</div>
					{show && list.data && (
						<PixleeMediaModal
							activeSlideIndex={initialModalSlideIndex}
							albumDetails={albumDetailsForPDP}
							initialMedia={list}
							UGCEventTypes={UGCEventTypes.pdp}
							showShopNextPrevButtonToggleOn={showShopNextPrevButtonToggleOn}
							productSku={productSku}
							modal={modal}
							{...modalConfig.captions.product}
						/>
					)}
				</>
			)}
		</PixleeWidget>
	);

}

export default PDPWidget;
